// export const permissionsKeys = {
//   page: 'param.security.users-admin.user',
//   pageBlockFind: 'param.security.users-admin.user.find',
//   pageBlockCreate: 'param.security.users-admin.user.create',
//   pageBlockUpdate: 'param.security.users-admin.user.update',
//   pageBlockRemove: 'param.security.users-admin.user.remove',
//   pageBlockUpdateActive: 'param.security.users-admin.user.update.active',
//   pageBlockUpdateInactivate: 'param.security.users-admin.user.update.inactivate',
// };
// 155:"param.dependencies.find"
// 156:"param.dependencies.create"
// 157:"param.dependencies.remove"
// 158:"param.dependencies.update"
export const permissionsKeys = {
  page: 'param.parameters-module.dependencies',
  pageBlockFind: 'param.dependencies.find',
  pageBlockCreate: 'param.dependencies.create',
  pageBlockUpdate: 'param.dependencies.update',
  pageBlockRemove: 'param.dependencies.remove',
  pageBlockUpdateInactivate: 'param.parameters-module.inactive.dependencies.update',
  pageBlockUpdateActive: 'param.parameters-module.activate.dependencies.update',
};
